const USER_TYPES = [
  { value: 'student', label: '학생' },
  { value: 'teacher', label: '교사' },
  { value: 'parent', label: '학부모' }
]

const INQUIRY_TYPES = [
  { value: 'login_fail', label: '로그인 불가' },
  { value: 'lost_account', label: '아이디·비밀번호 분실' },
  { value: 'screen_error', label: '화면 오류' },
  { value: 'etc', label: '기타' }
]

const GRADES = [1, 2, 3, 4, 5, 6]

// TODO(로그인 오류 신고): 반 목록을 학교별 API로 받을지 확정 전까지 고정 범위 사용
const CLASSES = Array.from({ length: 15 }, (_, i) => i + 1)

// 학교 검색 결과에 항상 붙는 "학교를 찾을 수 없음 / 모르겠어요" 응답
const UNKNOWN_SCHOOL = { id: 'UNKNOWN', name: '학교를 찾을 수 없어요 / 모르겠어요' }

const CONTENT_MIN_LENGTH = 20
// TODO(로그인 오류 신고): 기존 문의하기 최대 길이로 교체
const CONTENT_MAX_LENGTH = 1000

export {
  USER_TYPES,
  INQUIRY_TYPES,
  GRADES,
  CLASSES,
  UNKNOWN_SCHOOL,
  CONTENT_MIN_LENGTH,
  CONTENT_MAX_LENGTH
}
